import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-month-expansion-panel',
  templateUrl: './month-expansion-panel.component.html',
  styleUrls: ['./month-expansion-panel.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

/**
 * Month expansion panel for timeline organism
 */
export class MonthExpansionPanelComponent {
  @Input() date: Date | undefined;

  /**
   * Returns the date ordinal
   *  @param {Date | undefined} date
   *  @return {string};
   */
  getOrdinal(date: Date | undefined): string {
    if (!date) return '';
    const day = date.getDate();
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  }
}
